const DEFAULT_ZOOM_LEVEL = 16.2;

// util function outside of component
export const getZoomLevel = (map) => {
  const zoom = map?.getZoom();

  if (zoom && zoom > DEFAULT_ZOOM_LEVEL) return zoom;

  return DEFAULT_ZOOM_LEVEL;
};

export const flyTo = (map, position) =>
  map?.flyTo({
    center: [position.longitude, position.latitude],
    zoom: getZoomLevel(map),
    offset: [0, -150],
    essential: true,
  });

export const flyToPoi = (map, poi, poiStore) => {
  if (!map || !poi) {
    console.error('flyToPoi: map or poi missing');
    return;
  }
  const [longitude, latitude] = poi.location.coordinates;
  flyTo(map, { latitude, longitude });
  poiStore?.add(poi);
};
